import { render, staticRenderFns } from "./ReviewsBeauty.vue?vue&type=template&id=d1865584&scoped=true"
import script from "./ReviewsBeauty.vue?vue&type=script&lang=js"
export * from "./ReviewsBeauty.vue?vue&type=script&lang=js"
import style0 from "./ReviewsBeauty.vue?vue&type=style&index=0&id=d1865584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1865584",
  null
  
)

export default component.exports